
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MaterialModuleModule } from 'src/app/shared/material-module/material-module.module';
import { ComponentsModule } from 'src/app/shared/components/components.module';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { DirectivesModule } from 'src/app/shared/directives/directives.module';
import { Component } from '@angular/core';

@Component({
  selector: 'app-feedback',
    imports: [TranslateModule, RouterModule, ReactiveFormsModule, FormsModule, NgSelectModule, NgScrollbarModule, NgbModule, MaterialModuleModule, ComponentsModule, PipesModule, DirectivesModule],
  
  templateUrl: './feedback.component.html',
  styleUrl: './feedback.component.scss'
})
export class FeedbackComponent {

}
